module.exports = __webpack_public_path__ + "img/group.f83032c3.svg";